import {FACTION_CONFIGS} from './factions';
import {POLICY_CONFIGS} from './policies';
import {pluralizeRu} from '../utils/other/pluralizeRu';

// Вступительная колода, которую видит человек, впервые открывший игру
// (см. components/IntroSlides/IntroSlides.js). Тексты здесь, а не в разметке:
// это рекламный материал, который переписывается чаще, чем верстка.
//
// Обращение на «ты» — то же, что в обучении (chapter1.js, Ch1WelcomeModal) и в
// подсказках во время партии.
//
// Числа в тексте не пишутся руками: фракции и политики считаются по флагу
// implemented в их конфигах. Слова рядом склоняются под получившееся число
// (pluralizeRu), поэтому текст остается верным и при 13 фракциях, и при 21.
// Мок «Случайная» в счет не идет: играть за него нельзя, и implemented у него
// не стоит.
// Способности фракций пересказаны с их description в configs/factions.js;
// упоминать можно ТОЛЬКО фракции с implemented — обещать неиграбельное нельзя.
//
// Картинки — по одной на раскладку: узкие экраны получают mobile-кадр,
// остальные desktop (см. media в IntroSlides.css).
// accents — дословные подстроки из bullets, они подсвечиваются цветом
// (см. splitTextByAccents; тест конфига следит, чтобы подстрока находилась).
export const INTRO_SLIDES_PAGE_ID = 'IntroSlides';

const FACTIONS_COUNT = FACTION_CONFIGS.filter((config) => config.implemented).length;
const POLICIES_COUNT = POLICY_CONFIGS.filter((config) => config.implemented).length;

const FACTIONS_TEXT = `${FACTIONS_COUNT} ${pluralizeRu(FACTIONS_COUNT, 'фракция', 'фракции', 'фракций')}`;
const STYLES_TEXT = `${FACTIONS_COUNT} ${pluralizeRu(FACTIONS_COUNT, 'стиль', 'стиля', 'стилей')} игры`;
const POLICIES_TEXT = `${POLICIES_COUNT} ${pluralizeRu(POLICIES_COUNT, 'политика', 'политики', 'политик')}`;
// «…, которую/которые ты меняешь»: союз склоняется вместе с числом политик,
// иначе при одной политике вышло бы «1 политика, которые»
const POLICIES_CLAUSE = pluralizeRu(POLICIES_COUNT, 'которую', 'которые', 'которые');

export const INTRO_SLIDES = [
  {
    id: 'factions',
    imagePathMobile: '/img/other/intro_mobile_factions.jpg',
    imagePathDesktop: '/img/other/intro_desktop_factions.jpg',
    imageAlt: 'Портреты фракций Стратегикона',
    title: `${FACTIONS_TEXT} — ${STYLES_TEXT}`,
    bullets: [
      {
        text: 'У каждой свой способ побеждать: демоны устрашают противника, орки держат удар, лепреконы крадут золото,  — выбирай сам.',
        accents: ['свой способ побеждать'],
      },
      {
        text: 'Быстрые партии: 3 игрока за 30 минут.\nОт первого поселения до Империи.',
        accents: ['Быстрые партии', '30 минут'],
      },
      {
        text: '15+ боевых арен для 2–6 игроков.',
        accents: ['15+ боевых арен', '2–6 игроков'],
      },
    ],
    // Дерзкий тизер стоит на ПЕРВОМ слайде нарочно: он подогревает «Что ещё?»
    // и продолжает работать, даже если до второго слайда не долистали
    buttonLabel: 'Что ещё?',
  },
  {
    id: 'policies',
    imagePathMobile: '/img/other/intro_mobile_policies.jpg',
    imagePathDesktop: '/img/other/intro_desktop_policies.jpg',
    imageAlt: 'Карты политик Стратегикона',
    title: 'Адаптируй тактику на ходу',
    bullets: [
      {
        // Подсвечиваются и число, и дифференциатор: смена политик посреди
        // матча — то, чего нет у конкурентов, ей нельзя тонуть в сером тексте
        text: `${POLICIES_TEXT}, ${POLICIES_CLAUSE} ты меняешь прямо посреди матча. Под соперника и обстоятельства.`,
        accents: [POLICIES_TEXT, 'прямо посреди матча'],
      },
      {
        text: 'Обучение внутри игры за 15 минут.',
        accents: ['Обучение', '15 минут'],
      },
      {
        // «Зал славы» — как сам раздел в игре (GloryHallPage): обещание
        // должно называться тем же именем, что и фича, которую игрок найдет
        text: 'Соперники — живые игроки: победи их — и взойди на вершину Зала славы!',
        accents: ['Соперники — живые игроки', 'Зала славы'],
      },
    ],
    buttonLabel: 'Играть бесплатно!',
  },
];
